import _ from 'lodash';
import React, { Component, PropTypes } from 'react';
import { readComponentInstanceResourceList } from '../../lib/frankly';
import CardContainer from './CardContainer';
import ComponentLoader from '../../../shared/utils/ComponentLoader';
import ComponentTitle from 'components/shared/ComponentTitle';
import { TITLE_TYPE } from '../../constants/FRNBaseStyles';

class RailCardContainer extends Component {
  static propTypes = {
    FRN_rawResponses: PropTypes.array,
    startArticleIndex: PropTypes.number,
    railAlign: PropTypes.oneOf(['left', 'right']),
    color: PropTypes.string,
    railWidth: PropTypes.oneOf(['lg', 'sm']),
    title: PropTypes.string,
    titleColor: PropTypes.string,
    descriptionText: PropTypes.string,
    backgroundColor: PropTypes.string,
    overflowBackground: PropTypes.bool,
    edgeToEdge: PropTypes.bool,
    railComponents: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired
      })
    ),
    ads: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired
      })
    ),
    cardContainerProps: PropTypes.shape({
      gutterSpacing: PropTypes.string,
      backgroundColor: PropTypes.string,
      overflowBackground: PropTypes.bool,
      cards: PropTypes.arrayOf(
        PropTypes.shape({
          id: PropTypes.string.isRequired
        }).isRequired
      ).isRequired
    }).isRequired,
    titleType: PropTypes.string
  }

  static defaultProps = {
    railAlign: 'left',
    color: '#000000',
    railWidth: 'sm',
    titleColor: '#313131',
    edgeToEdge: false,
    titleType: TITLE_TYPE.MODULE_TITLE
  }

  render() {
    const {
      FRN_rawResponses = [],
      startArticleIndex = 0,
      railAlign,
      color,
      railWidth,
      title,
      titleColor,
      descriptionText,
      railComponents,
      backgroundColor: backgroundColorRail,
      overflowBackground: overflowBackgroundRail,
      ads,
      edgeToEdge,
      cardContainerProps: {
        gutterSpacing,
        backgroundColor: backgroundColorCard,
        overflowBackground: overflowBackgroundCard,
        cards
      },
      titleType
    } = this.props;

    const [
      {
        data: {
          abstract = '',
          headline = ''
        } = {}
      } = {}
    ] = FRN_rawResponses;

    const componentTitle = title !== undefined ? title : headline;
    const description = descriptionText !== undefined ? descriptionText : abstract;

    const content = [];
    const backgroundColor = !overflowBackgroundRail ? backgroundColorRail : null;

    content.push(
      <div className="CardContainerWrapper" key={content.length}>
        <CardContainer
          FRN_rawResponses={FRN_rawResponses}
          startArticleIndex={startArticleIndex}
          gutterSpacing={gutterSpacing}
          backgroundColor={backgroundColorCard}
          overflowBackground={overflowBackgroundCard}
          cards={cards}
          edgeToEdge={edgeToEdge}/>
      </div>
    );

    const descriptionContent = description ? <p className="Rail-description" dangerouslySetInnerHTML={{ __html: description.replace(/p>/g, 'span>') }} /> : null;

    const _buildComponent = (components, className) => {
      return components.map((component, index) => {
        return <div key={index} className={className}><RailComponentLoader orderNumber={index} railCardContainerContext={this} componentDefinition={component}/></div>;
      });
    };

    const railComponentContent = _buildComponent(railComponents, 'Rail-railComponent');
    const adComponentContent = _buildComponent(ads, 'Rail-adComponent');

    const railContent = (
      <div key={content.length} className={`Rail Rail-${railWidth} Rail-gutterSpacing--${gutterSpacing}`} style={{color}}>
        <div className="Rail-mainContainer">
          { componentTitle ? <ComponentTitle titleType={titleType} color={titleColor} title={componentTitle} /> : null }
          { descriptionContent }
          { railComponentContent }
        </div>
        <div className="Rail-adContainer">{ adComponentContent }</div>
      </div>
    );

    if (railAlign === 'left') {
      content.unshift(railContent);
    } else {
      content.push(railContent);
    }

    return (
      <div className="RailCardContainer">
        <div className="RailCardContainer-wrapper" style={{ backgroundColor }} >
          {content}
        </div>
        {overflowBackgroundRail &&
          <span className={`RailCardContainer-backgroundOverflow RailCardContainer-backgroundOverflow--${gutterSpacing}`}
            style={{ backgroundColor: backgroundColorRail }} />}
      </div>
    );
  }
}

class RailComponentLoader extends Component {
  static propTypes = {
    orderNumber: PropTypes.number,
    railCardContainerContext: PropTypes.object,
    componentDefinition: PropTypes.shape({
      id: PropTypes.string.isRequired
    }).isRequired
  }

  state = {
    ComponentClass: null,
    rawResponses: null
  }

  componentWillMount() {
    const {
      orderNumber,
      railCardContainerContext,
      componentDefinition: { id, FRN_resourceEndpoints }
    } = this.props;

    ComponentLoader.importReactComponent(id).then(ComponentClass =>
      this.setState({ ComponentClass })
    ).catch(() =>
      console.log('Error while loading the component')
    );

    if (FRN_resourceEndpoints) {
      readComponentInstanceResourceList(railCardContainerContext, { propPath: `railComponents[${orderNumber}]` }).then(resps => {
        this.setState({ rawResponses: resps });
      }).catch(() =>
        console.log('Error while getting data')
      );
    }
  }

  render() {
    const { componentDefinition: { props = {}, FRN_resourceEndpoints } } = this.props;
    const { ComponentClass, rawResponses } = this.state;

    if (!ComponentClass) {
      return null;
    }

    const childProps = FRN_resourceEndpoints ? _.assign(props, { FRN_rawResponses: rawResponses }) : props;

    return (
      <ComponentClass {...childProps}/>
    );
  }
}

export default RailCardContainer;



// WEBPACK FOOTER //
// ./app/components/news/RailCardContainer.js